import React from "react";
import { Field } from "redux-form";
import { email, minLength, required } from "../../../utils/validate";
import { toNumber, phoneNumberFormatter } from "../../../utils/formatters";
import Input from "../../Forms/Input/input";
import PropTypes from "prop-types";

export const minimumLength = minLength.bind(null, 10);

const ContactFieldSet = (props) => {
  const { displayMiniAppFields, displayFullAppFields } = props;

  return (
    <fieldset className="container">
      <legend className="row">Contact</legend>
      <div className="row">
        { displayMiniAppFields &&
          <div className="col-12 col-lg-6 contact-field">
            <Field
              name="email"
              label="Email"
              component={Input}
              type="email"
              validate={[required, email]}
              required={true}
              smallDisclosure={{
                text: "By providing your email address, you consent to our using it to communicate with you before and during the application process."
              }}
              htmlAttributes={{
                maxLength: "40"
              }}
            />
          </div>
        }
        { displayFullAppFields &&
          <div className="col-12 col-lg-6 contact-field">
            <Field
              name="phoneNumber"
              label="Phone number"
              component={Input}
              normalize={toNumber}
              format={phoneNumberFormatter}
              type="text"
              validate={[required, minimumLength]}
              required={true}
              htmlAttributes={{
                minLength: "12",
                maxLength: "12"
              }}
            />
          </div>
        }
      </div>
    </fieldset>);
};

ContactFieldSet.defaultProps = {
  displayMiniAppFields: true,
  displayFullAppFields: true
};

ContactFieldSet.propTypes = {
  displayMiniAppFields: PropTypes.bool,
  displayFullAppFields: PropTypes.bool
};

export default ContactFieldSet;

